"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createErrorMessage = require("./createErrorMessage");
Object.keys(_createErrorMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createErrorMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createErrorMessage[key];
    }
  });
});
